import { appConfig } from '../constants';

function getRandomArtistUrl(page = 0) {
  // array of all the letters in the alphabet
  const queries = [];
  'abcdefghijklmnopqrstuvwxyz'.split('').forEach((letter) => {
    queries.push(letter);
    queries.push(letter.toUpperCase());
    queries.push(`${letter}*`);
    queries.push(`${letter.toUpperCase()}*`);
    queries.push(`*${letter}`);
    queries.push(`*${letter}*`);
  });
  queries.push('');
  // This will get a random result out of the array above
  const randomQuery = queries[Math.floor(Math.random() * queries.length)];
  // const randomOffset = Math.floor(Math.random() * randomness);
  const randomYear = 2021
    - appConfig.yearOffset
    + Math.floor(Math.random() * appConfig.yearOffset);
  if (appConfig.genre === 'all') {
    return `https://api.spotify.com/v1/search?q=${randomQuery}%20year%3A${randomYear}&limit=50&offset=${
      page * 50
    }&type=artist&market=US`;
  }
  return `https://api.spotify.com/v1/search?q=${randomQuery}%20year%3A${randomYear}%20genre:${appConfig.genre}&limit=50&offset=${
    page * 50
  }&type=artist&market=US`;
}

export default getRandomArtistUrl;
